module.exports = __webpack_public_path__ + "img/0.3e5e1eaf.jpg";